export default class {
    constructor() {
    }

    init = () => {
        this.bindFormChange();
        this.releaseFormChangeOnSubmit();

    }

    _beforeUnloadListener = (event) => {
        // The confirm message cannot be changed
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
        event.preventDefault();
        event.returnValue = true;
    }

    bindFormChange = () => {
        let that = this;
        document.querySelectorAll('form input, form select, form textarea').forEach(function(element, index) {
            element.addEventListener('change', function(e) {

                // https://www.uriports.com/blog/easy-fix-for-blocked-attempt-beforeunload-confirmation-panel/#:~:text=How%20to%20fix%20this%20violation,listens%20to%20text%20input%20changes.
                // https://stackoverflow.com/questions/40570164/how-to-customize-the-message-changes-you-made-may-not-be-saved-for-window-onb
                addEventListener("beforeunload", that._beforeUnloadListener);
            });
        });
    }

    releaseFormChangeOnSubmit = () => {
        let that = this;
        document.querySelector('input[type=submit]').closest('form').addEventListener('submit', function(e) {
            e.preventDefault();
            removeEventListener("beforeunload", that._beforeUnloadListener);
            this.submit();
        });
    }

}